/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SelfEnrollType {
  SELF_ENROLL = 'SELF_ENROLL',
  NOT_SELF_ENROLL = 'NOT_SELF_ENROLL',
  UNKNOWN = 'UNKNOWN',
}
